import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "./apiHelper";
import { concatPathWithParams } from "./apiHelper";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_SECRET_API}`,
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  tagTypes: [
    "user_list",
    "user_groups_available",
    "user_details",
    "client_list",
    "residents_analytics"
  ],
  endpoints: (builder) => ({

    //!!___________USER PORTAL___________!!
    newUser: builder.mutation({
      query: (request) => ({
        url: `auth/user_details/`,
        method: "POST",
        body: request.body,
      }),
      invalidatesTags: ["user_list"],
    }),

    // Defaulted because calling this with no argument means "the current user"
    // (`auth/user_details/` with no params). Profile.js already called it that
    // way, which threw on `request.queryParams` — the route was unreachable, so
    // the crash had never been seen.
    getUserDetails: builder.query({
      query: (request = {}) => concatPathWithParams(`auth/user_details/`, request.queryParams),
      providesTags: ["user_details"],
    }),

    updateUserDetails: builder.mutation({
      query: (request) => ({
        url: `auth/user_details/`,
        method: "PATCH",
        body: request.body,
      }),
      invalidatesTags: ["user_list"],
    }),

    getUserList: builder.query({
      query: () => ({
        url: `auth/user_list_view/`,
      }),
      providesTags: ["user_list"],
    }),

    getUserGroupsAvailable: builder.query({
      query: () => ({
        url: `auth/user_groups_available/`,
      }),
      providesTags: ["user_groups_available"],
    }),

    deleteUser: builder.mutation({
      query: (request) => ({
        url: concatPathWithParams(`auth/user_details/`, request.body),
        method: "DELETE",
        body: request.body,
      }),
      invalidatesTags: ["user_list"],
    }),

    // Deactivate / reactivate. Its own endpoint rather than a field on
    // user_details: that handler rebuilds the user's groups from the request
    // body, so a partial PATCH there would strip every role they hold.
    setUserActive: builder.mutation({
      query: (request) => ({
        url: `auth/user/active/`,
        method: "PATCH",
        body: request.body,
      }),
      invalidatesTags: ["user_list"],
    }),

    //!!___________DBMS___________!!
    getClientList: builder.query({
      query: () => ({
        url: `${process.env.REACT_APP_DBMS_API}/sales/clients/`,
      }),
      providesTags: ["client_list"],
    }),

     getResidentsAnalytics: builder.query({
      query: () => ({
        url: `${process.env.REACT_APP_SMARTNODE_URL}/api/device/access-summary/`,
      }),
      providesTags: ["residents_analytics"],
    }),

  }),
});

export const {
  useNewUserMutation,
  useGetUserListQuery,
  useGetUserGroupsAvailableQuery,
  useGetUserDetailsQuery,
  useUpdateUserDetailsMutation,
  useGetClientListQuery,
  useDeleteUserMutation,
  useSetUserActiveMutation,
  useGetResidentsAnalyticsQuery


} = apiSlice;